// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-steps__task[data-v-083df902]{font-size:18px;color:#9c9c9c}.task-steps__task.completed .task-steps__task__name[data-v-083df902]{text-decoration:line-through}.task-steps__task__checkbox[data-v-083df902]{font-size:20px}.task-steps__task.small[data-v-083df902]{font-size:16px}.task-steps__task.small .task-steps__task__checkbox[data-v-083df902]{font-size:18px}\n", ""]);
// Exports
module.exports = exports;
